import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import config from '../../config'
import * as Api from '../../common/Api';

const initialState = {
    loading: false,
    reload: false,
    alertMessage: undefined,
    successMessage: undefined,
    list: null,
    listMatchReport: null,
};


export const getMatchListById = createAsyncThunk('matchListReport/get-by-id', async (id) => {
    const URL = `${config.services.ATLAS.apiUrl}/managed-lists/${id}`;
    const list = await Api.get(true, URL);
    return list;
});
export const createMatchReport = createAsyncThunk('matchListReport/createMatchReport',
    async ({id}) => {
        const GET_URL = `${config.services.ATLAS.apiUrl}/managed-list-matches`;
        const DOWNLOAD_LIST = `${GET_URL}/${id}/create-match-report`;
        return await Api.get(true,
            DOWNLOAD_LIST,
            {
                options: {
                },
                data: {
                }
            }
        );
    });

export const getMatchReportById = createAsyncThunk('matchListReport/get-match-report-by-id', async (id) => {
    console.log(`${config.services.ATLAS.apiUrl}/lists/${id}/match-report`);
    console.log(id);
    const listMatchReport = await Api.get(true, `${config.services.ATLAS.apiUrl}/lists/${id}/match-report`);
    return listMatchReport;
});


const listMatchReportSlice = createSlice({
    name: 'listMatchReportSlice', initialState,
    reducers: {
        clearState: (state) => {
            state.loading = false;
            state.reload = false;
            state.alertMessage = undefined;
            state.successMessage = undefined;
            state.list = null;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMatchListById.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getMatchListById.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.list = action.payload;
                }
            })
            .addCase(getMatchListById.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve managed list';
            })
            .addCase(createMatchReport.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.listMatchReport = undefined;
            })
            .addCase(createMatchReport.fulfilled, (state, action) => {
                state.alertMessage = undefined;
                state.successMessage = undefined;
                state.loading = false;
                if (action.payload) {
                    state.listMatchReport = action.payload;
                }
            })
            .addCase(createMatchReport.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to create match report for this list';
                state.successMessage = undefined;
                state.listMatchReport = undefined;
            })
            .addCase(getMatchReportById.pending, (state, action) => {
                state.loading = true;
                state.successMessage = undefined;
                state.alertMessage = undefined;
            })
            .addCase(getMatchReportById.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.listMatchReport = action.payload;
                }
            })
            .addCase(getMatchReportById.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = 'Unable to retrieve list report';
            });
    }
});

export const { clearState } = listMatchReportSlice.actions;
export default listMatchReportSlice.reducer;
